import { Switch, Route, Redirect } from "react-router-dom";
import { SocketProvider } from "./context/SocketContext";
import SessionLock from "./components/SessionLock";
import Home from "./pages/Home";
import NoAccess from "./pages/NoAccess";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import PurnimaMember from "./pages/Purnima-members";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import RoleList from "./pages/role/List";
import RoleForm from "./pages/role/Form";
import StaffList from "./pages/staff/List";
import StaffForm from "./pages/staff/Form";
import StaffRoleList from "./pages/staff_role/List";

import UsersList from "./pages/sn_users/List";
import UsersForm from "./pages/sn_users/Form";
import UsersView from "./pages/sn_users/View";

import SuspenseList from "./pages/sn_suspense_entries/List";
import SuspenseForm from "./pages/sn_suspense_entries/Form";
import SuspenseView from "./pages/sn_suspense_entries/View";

import RegistrationList from "./pages/sn_registration/List";
import RegistrationForm from "./pages/sn_registration/Form";

import AnnouncedList from "./pages/sn_announced/List";
import AnnouncedForm from "./pages/sn_announced/Form";

import PurnimaUserList from "./pages/sn_purnima_form/List";
import PurnimaUserForm from "./pages/sn_purnima_form/Form";

import PosterList from "./pages/sn_poster/List";
import PosterBuilderPage from "./pages/sn_poster_builder";
import PaymentReminderRulesPage from "./pages/sn_payment_reminder_rules";
import ReceiptTemplatePage from "./pages/sn_receipt_template";
import DailyPosterPage from "./pages/sn_daily_poster";
import ReferralReport from "./pages/sn_referral_report";
import GeoReport from "./pages/sn_geo_report";

import VisheshSahyogiList from "./pages/sn_vishesh_sahyogi/List";
import VisheshSahyogiForm from "./pages/sn_vishesh_sahyogi/Form";

import InquiryList from "./pages/sn_inquiry/List";
import InquiryForm from "./pages/sn_inquiry/Form";

import WorkManagmentList from "./pages/sn_work_managment/List";
import WorkManagmentForm from "./pages/sn_work_managment/Form";

// Work Tracking System
import { StaffDashboard, AddManualActivity, TeamDashboard } from "./pages/sn_work_tracking";

import VillageList from "./pages/sn_village/List";
import VillageForm from "./pages/sn_village/Form";
import VillageBulkCorrection from "./pages/sn_village/BulkCorrection";

import BankAccountPage from "./pages/sn_bank_account";
import SpecialOccasionPage from "./pages/sn_special_occasion";

import MessageLogList from "./pages/sn_message_logs/List";

import VisitorList from "./pages/sn_visitor/List";
import VisitorForm from "./pages/sn_visitor/Form";
  

import PaymentsList from "./pages/sn_payments/List";
import PaymentsForm from "./pages/sn_payments/Form";
import PaymentsView from "./pages/sn_payments/ViewPayments"; 
import AddUserPayment from "./pages/sn_payments/AddUserPayment"; 
import EditUserPayment from "./pages/sn_payments/EditUserPayment"; 
import TrackingList from "./pages/sn_tracking/List";
import TrashPayments from "./pages/sn_payments/TracePayment";

import ManualReport from "./pages/sn_reports/ManualReport";
import BirthdayReport from "./pages/sn_reports/BirthdayReport";
import CallingReport from "./pages/sn_reports/CallingReport";
import CallingModule from "./pages/sn_reports/CallingModule";
import YealyReport from "./pages/sn_reports/YealyReport";
import CalendarReport from "./pages/sn_reports/CalendarReport";
import ImportData from "./pages/sn_reports/ImportData";
import ContinuityReport from "./pages/sn_reports/ContinuityReport";
import TransactionSummaryReport from "./pages/sn_reports/TransactionSummaryReport";

import ThankYouPage from "./pages/thank-you"; 
import OnlinePaymentUser from "./pages/Online-payments";
import PaymentSuccess from "./pages/Payment-success";
import DecodeUser from "./pages/Decode-User";

import Visitor from "./pages/New-visitor";
import Visitors from "./pages/New-Visitor-List";
import { canAccessRoute, isDirectoryOnlyUser } from "./components/permissions";

import PublicRegistrationForm from "./pages/Reg-Form";
import BirthdayForm from "./pages/BirthdayForm";
import QuickPay from "./pages/QuickPay";
import BusinessDirectoryForm from "./pages/BusinessDirectoryForm";
import BusinessDirectoryUpdate from "./pages/BusinessDirectoryUpdate";
import PublicBusinessDirectory from "./pages/PublicBusinessDirectory";
import ContributionsList from "./pages/sn_contributions/List";
import FestivalList      from "./pages/sn_festivals/List";
import AdminStatusList   from "./pages/sn_admin_status/List";
import DailyQuoteList    from "./pages/sn_daily_quote/List";
import MusicLibrary      from "./pages/sn_music/MusicLibrary";
import GalleryAdmin      from "./pages/sn_gallery/GalleryAdmin";
import BusinessSectorList from "./pages/sn_business_directory/SectorList";
import BusinessSubmissionList from "./pages/sn_business_directory/SubmissionList";
import DirectoryConfig from "./pages/sn_business_directory/DirectoryConfig";
import DirectoryMobileApp from "./pages/sn_business_directory/DirectoryMobileApp";

import CompExamResults from "./pages/sn_comp_exam_results/List";
import CompExamResultsForm from "./pages/sn_comp_exam_results/Form";
import StudentSupportList from "./pages/sn_student_support/List";
import JobsList from "./pages/sn_jobs/List";
import VivahList from "./pages/sn_vivah/List";
import SamajParichayList    from "./pages/sn_samaj_parichay/List";
import SamajPropertiesList  from "./pages/sn_samaj_properties/List";
import SammelanList from "./pages/sn_sammelan/List";
import GramPramukhList from "./pages/sn_gram_pramukh/List";
import GotraDirectoryList from "./pages/sn_gotra_directory/List";
import ExpenditureMgmt  from "./pages/ExpenditureMgmt";
import FinancialReports from "./pages/FinancialReports";


// Add these imports at the top
import BeneficiariesList from "./pages/sn_beneficiaries/List";
import BeneficiariesForm from "./pages/sn_beneficiaries/Form";
import BeneficiariesView from "./pages/sn_beneficiaries/View";

import PurposesList from "./pages/sn_purposes/List";
import PurposesForm from "./pages/sn_purposes/Form";
import PurposesView from "./pages/sn_purposes/View";

import ExpendituresList from "./pages/sn_expenditures/List";
import ExpendituresForm from "./pages/sn_expenditures/Form";
import ExpendituresView from "./pages/sn_expenditures/View";
// import ApprovalFlow from "./pages/sn_expenditures/ApprovalFlow";
import ApprovalWorkflow from "./pages/sn_expenditures/ApprovalWorkflow";

import BudgetAllocationsList from "./pages/sn_budget_allocations/List";
import BudgetAllocationsForm from "./pages/sn_budget_allocations/Form";
import BudgetDashboard from "./pages/sn_budget_allocations/BudgetDashboard";

import ExpenditureReports from "./pages/sn_expenditure_reports/ExpenditureReports";
import BudgetReports from "./pages/sn_expenditure_reports/BudgetReports";
import ApprovalWorkflowReport from "./pages/sn_expenditure_reports/ApprovalWorkflowReport";

import UserPortalLogin from "./pages/UserPortalLogin";
import UserPortal from "./pages/UserPortal";

import { FestivalCampaignList, FestivalCampaignForm, SendCampaign } from "./pages/sn_festival_campaign";
import { AppSettings } from "./pages/sn_app_settings";
import { MonthlyReportList, MonthlyReportForm, MonthlyReportSend } from "./pages/sn_monthly_reports";
import { PortalUpdatesList, PortalUpdatesForm } from "./pages/sn_portal_updates";
import { AdminNotificationsList, AdminNotificationsForm } from "./pages/sn_admin_notifications";
import { AdminCommunityPosts } from "./pages/sn_community_board";
import { StaffTrackingHub, AdminTrackingHub } from "./pages/sn_staff_tracking";
import StaffChat from "./pages/sn_staff_chat";

// Population imports
import PopDashboard from "./pages/pop_dashboard/index";
import PopEducationList from "./pages/pop_education/List";
import PopOccupationsList from "./pages/pop_occupations/List";
import PopCountryList from "./pages/pop_country/List";
import PopStatesList from "./pages/pop_states/List";
import PopDistrictsList from "./pages/pop_districts/List";
import PopTehsilsList from "./pages/pop_tehsils/List";
import PopPanchayatList from "./pages/pop_panchayat/List";
import PopVillageList from "./pages/pop_village/List";
import PopFamiliesList from "./pages/pop_families/List";
import PopFamiliesForm from "./pages/pop_families/Form";
import PopFamilyMemberList from "./pages/pop_family_member/List";
import PopFamilyMemberForm from "./pages/pop_family_member/Form";
 
const ProtectedRoute = ({ component: Component, path, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      canAccessRoute(path) ? (
        <Component {...props} />
      ) : (
        <Redirect to="/no-access" />
      )
    }
  />
); 

  
function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/sign-up" exact component={SignUp} />
        <Route path="/purnima-member" exact component={PurnimaMember} />
        <Route path="/purnima-member-confirm" exact component={ThankYouPage} />
        <Route path="/donation-payment" exact component={OnlinePaymentUser} /> 
        <Route path="/payment-success" exact component={PaymentSuccess} /> 
        <Route path="/decode-user" exact component={DecodeUser} />
        <Route exact path="/new-visitors" component={Visitor} />
        <Route exact path="/visitors" component={Visitors} />
        <Route path="/public-registration" exact component={PublicRegistrationForm} />
        <Route path="/form-registration" exact component={PublicRegistrationForm} />
        <Route path="/birthday-form" exact component={BirthdayForm} />
        <Route path="/quick-pay"    exact component={QuickPay} />
        <Route path="/business-directory-form" exact component={BusinessDirectoryForm} />
        <Route path="/business-directory-update" exact component={BusinessDirectoryUpdate} />
        <Route path="/directory-mobile" exact component={DirectoryMobileApp} />
        <Route path="/business-directory-public" exact component={PublicBusinessDirectory} />

        {/* USER PORTAL ROUTES - These should work without Main layout */}
        <Route path="/user-portal-login" exact component={UserPortalLogin} />
        <Route path="/user-portal" exact component={UserPortal} />
       
        
        <Route path="/sign-in" exact component={SignIn} />

        {/* Root path guard: unauthenticated visitors on the public portal go to the
            public form; on the admin portal they go to sign-in; logged-in users go
            to their appropriate home (prevents the catch-all below from rendering
            Main and triggering the admin login redirect for public users). */}
        <Route exact path="/" render={() => {
          const isPublicPortal = window.location.hostname === 'portal.brahmdhamtirth.org';
          if (!localStorage.getItem('accessToken')) {
            return <Redirect to={isPublicPortal ? '/business-directory-form' : '/sign-in'} />;
          }
          return isDirectoryOnlyUser()
            ? <Redirect to="/directory-mobile" />
            : <Redirect to="/dashboard" />;
        }} />

        <SocketProvider>
        <SessionLock />
        <Main>
        <Switch>
          {/* Directory-only staff → go straight to mobile view */}
          <Route exact path="/" render={() =>
            isDirectoryOnlyUser()
              ? <Redirect to="/directory-mobile" />
              : <Home />
          } />
          <Route exact path="/no-access" component={NoAccess} />
          <ProtectedRoute exact path="/dashboard" component={Home} />
          <Route exact path="/tables" component={Tables} />
          <Route exact path="/billing" component={Billing} />
          <Route exact path="/rtl" component={Rtl} />
          <Route exact path="/profile" component={Profile} />
          
          {/* Role */}
          <Route exact path="/staff-role" component={StaffRoleList} />
          <ProtectedRoute exact path="/role" component={RoleList} />
          {/* <Route exact path="/role" component={RoleList} /> */}
          <ProtectedRoute exact path="/role/add" component={RoleForm} />
          <ProtectedRoute exact path="/role/update/:id" component={RoleForm} />
           {/* Staff */}
          <ProtectedRoute exact path="/staff" component={StaffList} />
          <ProtectedRoute exact path="/staff/add" component={StaffForm} />
          <ProtectedRoute exact path="/staff/update/:id" component={StaffForm} />


          <ProtectedRoute exact path="/users" component={UsersList} />

          {/* <Route exact path="/users" component={UsersList} /> */}
          <ProtectedRoute exact path="/users/add" component={UsersForm} />
          <ProtectedRoute exact path="/users/update/:id" component={UsersForm} />
          <ProtectedRoute exact path="/users/view/:id" component={UsersView} />
          
          <ProtectedRoute exact path="/payments" component={PaymentsList} />
          {/* <Route exact path="/payments-history" component={PaymentsList} /> */}
          <ProtectedRoute exact path="/payments/add" component={PaymentsForm} />
          <ProtectedRoute exact path="/payments/update/:id" component={EditUserPayment} />
          <ProtectedRoute exact path="/payments/view/:id" component={PaymentsView} />
          <ProtectedRoute exact path="/payments/add_user_payment" component={AddUserPayment} />
          <ProtectedRoute exact path="/tracking" component={TrackingList} />
          <ProtectedRoute exact path="/trash-payments" component={TrashPayments} />

          <ProtectedRoute exact path="/suspense-entries" component={SuspenseList} />
          <ProtectedRoute exact path="/suspense-entries/add" component={SuspenseForm} />
          <ProtectedRoute exact path="/suspense-entries/update/:id" component={SuspenseForm} />
          <ProtectedRoute exact path="/suspense-entries/view/:id" component={SuspenseView} />

          <ProtectedRoute exact path="/registration" component={RegistrationList} />
          <ProtectedRoute exact path="/registration/add" component={RegistrationForm} />
          <ProtectedRoute exact path="/registration/update/:id" component={RegistrationForm} />

          <ProtectedRoute exact path="/visitor" component={VisitorList} />
          <ProtectedRoute exact path="/visitor/add" component={VisitorForm} />
          <ProtectedRoute exact path="/visitor/update/:id" component={VisitorForm} />


          <ProtectedRoute exact path="/announced" component={AnnouncedList} />
          <ProtectedRoute exact path="/announced/add" component={AnnouncedForm} />
          <ProtectedRoute exact path="/announced/update/:id" component={AnnouncedForm} />

          <ProtectedRoute exact path="/purnima-form" component={PurnimaUserList} />
          <ProtectedRoute exact path="/purnima-form/add" component={PurnimaUserForm} />
          <ProtectedRoute exact path="/purnima-form/update/:id" component={PurnimaUserForm} />

          <ProtectedRoute exact path="/poster" component={PosterList} />
          <ProtectedRoute exact path="/poster-builder" component={PosterBuilderPage} />
          <ProtectedRoute exact path="/receipt-template" component={ReceiptTemplatePage} />
          <ProtectedRoute exact path="/bank-account" component={BankAccountPage} />
          <ProtectedRoute exact path="/special-occasion" component={SpecialOccasionPage} />
          <ProtectedRoute exact path="/daily-poster" component={DailyPosterPage} />
          <ProtectedRoute exact path="/reports/referral-report" component={ReferralReport} />
          <ProtectedRoute exact path="/reports/geo-report" component={GeoReport} />
          <ProtectedRoute exact path="/payment-reminder-rules" component={PaymentReminderRulesPage} />
          

          <ProtectedRoute exact path="/vishesh-sahyogi" component={VisheshSahyogiList} />
          <ProtectedRoute exact path="/vishesh-sahyogi/add" component={VisheshSahyogiForm} />
          <ProtectedRoute exact path="/vishesh-sahyogi/update/:id" component={VisheshSahyogiForm} />

          <ProtectedRoute exact path="/comp-exam-results" component={CompExamResults} />
          <ProtectedRoute exact path="/comp-exam-results/add" component={CompExamResultsForm} />
          <ProtectedRoute exact path="/comp-exam-results/update/:id" component={CompExamResultsForm} />

          {/* Student Support */}
          <ProtectedRoute exact path="/student-support" component={StudentSupportList} />


          <ProtectedRoute exact path="/inquiry" component={InquiryList} />
          <ProtectedRoute exact path="/inquiry/add" component={InquiryForm} />
          <ProtectedRoute exact path="/inquiry/update/:id" component={InquiryForm} />

          <ProtectedRoute exact path="/work_managment" component={WorkManagmentList} />
          <ProtectedRoute exact path="/work_managment/add" component={WorkManagmentForm} />
          <ProtectedRoute exact path="/work_managment/update/:id" component={WorkManagmentForm} />

          {/* Work Tracking System -  */}
          <ProtectedRoute exact path="/work-tracking" component={StaffDashboard} />
          <ProtectedRoute exact path="/work-tracking/add-activity" component={AddManualActivity} />
          <ProtectedRoute exact path="/work-tracking/team-dashboard" component={TeamDashboard} />

          <ProtectedRoute exact path="/village" component={VillageList} />
          <ProtectedRoute exact path="/village/add" component={VillageForm} />
          <ProtectedRoute exact path="/village/update/:id" component={VillageForm} />
          <ProtectedRoute exact path="/village/bulk-correction" component={VillageBulkCorrection} />

          <ProtectedRoute exact path="/message-log" component={MessageLogList} /> 

          <ProtectedRoute exact path="/reports/manual-report" component={ManualReport} />
          <ProtectedRoute exact path="/reports/birthday-list" component={BirthdayReport} />
          <ProtectedRoute exact path="/reports/calling-report" component={CallingReport} />
          <ProtectedRoute exact path="/calling-module" component={CallingModule} />
          <ProtectedRoute exact path="/reports/yearly-report" component={YealyReport} />
          <ProtectedRoute exact path="/reports/calendar-report" component={CalendarReport} />
          <ProtectedRoute exact path="/reports/import" component={ImportData} />
          <ProtectedRoute exact path="/reports/payment-continuity" component={ContinuityReport} />
          <ProtectedRoute exact path="/reports/transaction-summary" component={TransactionSummaryReport} />


          {/* Beneficiaries */}
          <ProtectedRoute exact path="/beneficiaries" component={BeneficiariesList} />
          <ProtectedRoute exact path="/beneficiaries/add" component={BeneficiariesForm} />
          <ProtectedRoute exact path="/beneficiaries/update/:id" component={BeneficiariesForm} />
          <ProtectedRoute exact path="/beneficiaries/view/:id" component={BeneficiariesView} />

          {/* Purposes */}
          <ProtectedRoute exact path="/purposes" component={PurposesList} />
          <ProtectedRoute exact path="/purposes/add" component={PurposesForm} />
          <ProtectedRoute exact path="/purposes/update/:id" component={PurposesForm} />
          <ProtectedRoute exact path="/purposes/view/:id" component={PurposesView} />

          {/* Expenditures */}
          <ProtectedRoute exact path="/expenditures" component={ExpendituresList} />
          <ProtectedRoute exact path="/expenditures/add" component={ExpendituresForm} />
          <ProtectedRoute exact path="/expenditures/update/:id" component={ExpendituresForm} />
          <ProtectedRoute exact path="/expenditures/view/:id" component={ExpendituresView} />
          {/* <ProtectedRoute exact path="/expenditures/approval/:id" component={ApprovalFlow} /> */}
          <ProtectedRoute exact path="/approval-workflow" component={ApprovalWorkflow} />

          {/* Budget Allocations */}
          <ProtectedRoute exact path="/budget-allocations" component={BudgetAllocationsList} />
          <ProtectedRoute exact path="/budget-allocations/add" component={BudgetAllocationsForm} />
          <ProtectedRoute exact path="/budget-allocations/update/:id" component={BudgetAllocationsForm} />
          <ProtectedRoute exact path="/budget-allocations/dashboard" component={BudgetDashboard} />

          {/* Expenditure Mgmt & Financial Reports — tabbed wrappers */}
          <ProtectedRoute exact path="/expenditure-mgmt"  component={ExpenditureMgmt} />
          <ProtectedRoute exact path="/financial-reports" component={FinancialReports} />
          {/* Expenditure Reports */}
          {/* Reports */}
          <ProtectedRoute exact path="/reports/expenditure-reports" component={ExpenditureReports} />
          <ProtectedRoute exact path="/reports/budget-reports" component={BudgetReports} />
          <ProtectedRoute exact path="/reports/approval-workflow" component={ApprovalWorkflowReport} />

          {/* Monthly Reports */}
          <ProtectedRoute exact path="/monthly-reports"           component={MonthlyReportList} />
          <ProtectedRoute exact path="/monthly-reports/add"       component={MonthlyReportForm} />
          <ProtectedRoute exact path="/monthly-reports/edit/:id"  component={MonthlyReportForm} />
          <ProtectedRoute exact path="/monthly-reports/send/:id"  component={MonthlyReportSend} />
          {/* Portal Updates — Community Activity Feed */}
          <ProtectedRoute exact path="/admin-notifications"        component={AdminNotificationsList} />
          <ProtectedRoute exact path="/admin-notifications/send"   component={AdminNotificationsForm} />
          <ProtectedRoute exact path="/community-board"            component={AdminCommunityPosts} />
          <ProtectedRoute exact path="/portal-updates"           component={PortalUpdatesList} />
          <ProtectedRoute exact path="/portal-updates/add"       component={PortalUpdatesForm} />
          <ProtectedRoute exact path="/portal-updates/edit/:id"  component={PortalUpdatesForm} />

          {/* Staff Tracking */}
          <ProtectedRoute exact path="/staff-tracking"       component={StaffTrackingHub} />
          <ProtectedRoute exact path="/staff-tracking/admin" component={AdminTrackingHub} />

          {/* Festival Campaign */}
          <ProtectedRoute exact path="/festival-campaign" component={FestivalCampaignList} />
          <ProtectedRoute exact path="/festival-campaign/add" component={FestivalCampaignForm} />
          <ProtectedRoute exact path="/festival-campaign/edit/:id" component={FestivalCampaignForm} />
          <ProtectedRoute exact path="/festival-campaign/send/:id" component={SendCampaign} />

          {/* API Settings */}
          <ProtectedRoute exact path="/app-settings" component={AppSettings} />

          {/* Staff Chat */}
          <Route exact path="/staff-chat" render={() =>
            localStorage.getItem('staffId')
              ? <StaffChat />
              : <Redirect to="/no-access" />
          } />

          {/* Population */}
          <Route exact path="/pop-dashboard" component={PopDashboard} />
          <Route exact path="/pop-education" component={PopEducationList} />
          <Route exact path="/pop-occupations" component={PopOccupationsList} />
          <Route exact path="/pop-country" component={PopCountryList} />
          <Route exact path="/pop-states" component={PopStatesList} />
          <Route exact path="/pop-districts" component={PopDistrictsList} />
          <Route exact path="/pop-tehsils" component={PopTehsilsList} />
          <Route exact path="/pop-panchayat" component={PopPanchayatList} />
          <Route exact path="/pop-village" component={PopVillageList} />

          {/* Population - Families */}
          <Route exact path="/pop-families" component={PopFamiliesList} />
          <Route exact path="/pop-families/add" component={PopFamiliesForm} />
          <Route exact path="/pop-families/update/:id" component={PopFamiliesForm} />

          {/* Jobs (Rozgar Setu) */}
          <ProtectedRoute exact path="/jobs-admin" component={JobsList} />

          {/* Vivah Parichay (Matrimony) */}
          <ProtectedRoute exact path="/vivah-admin" component={VivahList} />

          {/* Samaj Parichay (Cultural Knowledge) */}
          <ProtectedRoute exact path="/samaj-parichay"    component={SamajParichayList} />
          <ProtectedRoute exact path="/samaj-properties" component={SamajPropertiesList} />

          {/* Sammelan Events */}
          <ProtectedRoute exact path="/sammelan" component={SammelanList} />

          {/* Gram Pramukh (Village Representatives) */}
          <ProtectedRoute exact path="/gram-pramukh" component={GramPramukhList} />

          {/* Gotra Directory */}
          <ProtectedRoute exact path="/gotra-directory" component={GotraDirectoryList} />

          {/* Samajik Yogdan — Social Contributions */}
          <ProtectedRoute exact path="/contributions"  component={ContributionsList} />
          {/* Festivals */}
          <ProtectedRoute exact path="/festivals"      component={FestivalList} />
          {/* Admin 24hr Status Photos */}
          <ProtectedRoute exact path="/admin-status"   component={AdminStatusList} />
          {/* Daily Quotes */}
          <ProtectedRoute exact path="/daily-quotes"   component={DailyQuoteList} />
          <ProtectedRoute exact path="/music-library"  component={MusicLibrary} />
          <ProtectedRoute exact path="/gallery"         component={GalleryAdmin} />

          {/* Business Directory */}
          <ProtectedRoute exact path="/business-directory/sectors" component={BusinessSectorList} />
          <ProtectedRoute exact path="/business-directory" component={BusinessSubmissionList} />
          <ProtectedRoute exact path="/business-directory/config" component={DirectoryConfig} />

          {/* Population - Family Members */}
          <Route exact path="/pop-family-member" component={PopFamilyMemberList} />
          <Route exact path="/pop-family-member/add" component={PopFamilyMemberForm} />
          <Route exact path="/pop-family-member/update/:id" component={PopFamilyMemberForm} />

        </Switch>

      </Main>
      </SocketProvider>
      </Switch>
    </div>
  );
}

export default App;
